import api from 'api/apiInstance';

export function adviceRoomGenerateTokenApi(path: string) {
  return {
    path,
    POST: () => api.post<{ token: string }>(path),
  };
}
